import React from "react";
import { Habit } from "../types";

interface ProgressModalProps {
  isOpen: boolean;
  habit: Habit | null;
  value: number | '';
  onValueChange: (value: number | '') => void;
  onSave: () => void;
  onCancel: () => void;
}

export const ProgressModal: React.FC<ProgressModalProps> = ({
  isOpen,
  habit,
  value,
  onValueChange,
  onSave,
  onCancel,
}) => {
  if (!isOpen || !habit) return null;

  const isValidInput = value !== '' && !isNaN(Number(value)) && Number(value) >= 0;

  return (
    <div
      style={{
        position: "fixed",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "8px",
          width: "90%",
          maxWidth: "300px",
        }}
      >
        <h3>Track Progress</h3>
        <p>How many {habit.progressUnit || 'units'} did you complete?</p>
        <input
          type="number"
          value={value}
          onChange={(e) => {
            const val = e.target.value;
            onValueChange(val === '' ? '' : Number(val));
          }}
          style={{
            width: "100%",
            padding: "8px",
            marginBottom: "20px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            backgroundColor: "#fff",
            color: "#000",
          }}
          min="0"
          autoFocus
          onFocus={(e) => e.target.select()}
        />
        <div style={{ display: "flex", gap: "10px" }}>
          <button
            onClick={onCancel}
            style={{
              flex: 1,
              padding: "8px",
              backgroundColor: "#6c757d",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
          <button
            onClick={onSave}
            disabled={!isValidInput}
            style={{
              flex: 1,
              padding: "8px",
              backgroundColor: "#28a745",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
              cursor: isValidInput ? "pointer" : "not-allowed",
              opacity: isValidInput ? 1 : 0.5,
            }}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};